import { ProgressSpinner } from "primereact/progressspinner";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import useRequiredFields from "../../../../hooks/useRequiredFields";
import FormValidation from "../../../Common/FormValidation";
import Http from "../../../Common/Http";

const Edit = (props) => {
  const navigate = useNavigate();
  const [inputs, setInputs] = useState({});
  const { id } = useParams();
  const [staff, setStaff] = useState({});
  const [error, setError] = useState({});
  const { checkRequiredFields } = useRequiredFields();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);

    const fetchData = async () => {
      try {
        const transactionRes = await Http.get("/transaction/" + id + "/edit");
        setInputs({
          hr_staff_basic_info_id: transactionRes.data.hr_staff_basic_info_id,
          total_amount: transactionRes.data.total_amount,
          date: transactionRes.data.date,
          remarks: transactionRes.data.remarks,
          effective_month: transactionRes.data.effective_month,
          no_of_installments: transactionRes.data.no_of_installments,
          effective_year: transactionRes.data.effective_year,

        });

        const staffRes = await Http.get("/staff");
        setStaff(staffRes.data);
      } catch (error) {
        console.error("Fetch error:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // const fetchData = () => {
  //   Http.get("/transaction/" + id + "/edit").then((res) => {
  //     setInputs({
  //       hr_staff_basic_info_id: res.data.hr_staff_basic_info_id,
  //       total_amount: res.data.total_amount,
  //       date: res.data.date,
  //       no_of_installments: res.data.no_of_installments,
  //       remarks: res.data.remarks,
  //     });
  //   });
  //   Http.get("/staff").then((res) => {
  //     setStaff(res.data);
  //   });
  // };

  // useEffect(() => {
  //   fetchData();
  // }, []);

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };

  const formSubmit = () => {
    if (checkRequiredFields()) {
      inputs.type = "salary_advance";
      Http.put("/transaction/" + id, inputs)
        .then((res) => {
          navigate("/salary-advance", {
            state: { message: res.data.message, type: res.data.type },
          });
        })
        .catch(function (e) {
          setError(e.response.data.errors);
        });
    }
  };

  return (
    <div>
      {/* <LoaderComponent /> */}
      <div className="am-mainpanel">
        <div className="am-pagetitle">
          <h5 className="am-title">Edit Salary Advance Form</h5>
        </div>
        <div className="am-pagebody">
          <div className="card pd-20 pd-sm-40">
            <h6 className="card-body-title mg-sm-b-30">
              Edit Salary Advance Form
            </h6>
            <div className="row">
              <div className="col-lg">
                <FormValidation error={error} />
              </div>
            </div>
            {loading ? (
              <ProgressSpinner />
            ) : (
              <>
                <div className="row">
                  <div className="col-lg">
                    <label htmlFor="">
                      Staff <i className="fa fa-star required"></i>
                    </label>
                    <select
                      className="form-control"
                      name="hr_staff_basic_info_id"
                      onChange={handleChange}
                    >
                      <option value="">Select Staff</option>
                      {Array.from(staff).map((item, index) => (
                        <option
                          value={item.id}
                          key={item.id}
                          selected={
                            inputs.hr_staff_basic_info_id === item.id
                              ? true
                              : false
                          }
                        >
                          {item.card_no + " - " + item.name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-lg">
                    <label>
                      Total Amount <i className="fa fa-star required"></i>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="total_amount"
                      value={inputs.total_amount || ""}
                      onChange={handleChange}
                      data-required
                    />
                  </div>
                  <div className="col-lg">
                    <label>
                      Date <i className="fa fa-star required"></i>
                    </label>
                    <input
                      type="date"
                      className="form-control"
                      name="date"
                      value={inputs.date || ""}
                      onChange={handleChange}
                      data-required
                    />
                  </div>

                </div>
                <div className="row mt-3">
                  <div className="col-lg">
                    <label>No Of Installments</label>
                    <input
                      type="text"
                      className="form-control"
                      name="no_of_installments"
                      value={inputs.no_of_installments || ""}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-lg">
                    <label>Effective Year <i className="fa fa-star required"></i></label>

                    <select
                      className="form-control"
                      name="effective_year"
                      onChange={handleChange}
                      value={inputs.effective_year || ""}

                      data-required
                    >
                      <option value="">Select Year</option>
                      <option
                        value="2022"
                        selected={inputs.year === 2022 ? true : false}
                      >
                        2022
                      </option>
                      <option
                        value="2023"
                        selected={inputs.year === 2023 ? true : false}
                      >
                        2023
                      </option>
                      <option
                        value="2024"
                        selected={inputs.year === 2024 ? true : false}
                      >
                        2024
                      </option>
                      <option
                        value="2025"
                        selected={inputs.year === 2025 ? true : false}
                      >
                        2025
                      </option>
                      <option
                        value="2026"
                        selected={inputs.year === 2026 ? true : false}
                      >
                        2026
                      </option>
                      <option
                        value="2027"
                        selected={inputs.year === 2027 ? true : false}
                      >
                        2027
                      </option>
                      <option
                        value="2028"
                        selected={inputs.year === 2028 ? true : false}
                      >
                        2028
                      </option>
                      <option
                        value="2029"
                        selected={inputs.year === 2029 ? true : false}
                      >
                        2029
                      </option>
                      <option
                        value="2030"
                        selected={inputs.year === 2030 ? true : false}
                      >
                        2030
                      </option>
                    </select>
                  </div>
                  <div className="col-lg">
                    <label>Effective Month <i className="fa fa-star required"></i></label>
                    <select
                      className="form-control"
                      name="effective_month"
                      value={inputs.effective_month || ""}
                      onChange={handleChange}
                      data-required
                    >
                      <option
                        value=""
                        selected
                        disabled

                      >
                        Select Month
                      </option>
                      <option
                        value="01"
                        selected={
                          inputs.month === "01" || inputs.month === 1
                            ? true
                            : false
                        }
                      >
                        January
                      </option>
                      <option
                        value="02"
                        selected={
                          inputs.month === "02" || inputs.month === 2
                            ? true
                            : false
                        }
                      >
                        February
                      </option>
                      <option
                        value="03"
                        selected={
                          inputs.month === "03" || inputs.month === 3
                            ? true
                            : false
                        }
                      >
                        March
                      </option>
                      <option
                        value="04"
                        selected={
                          inputs.month === "04" || inputs.month === 4
                            ? true
                            : false
                        }
                      >
                        April
                      </option>
                      <option
                        value="05"
                        selected={
                          inputs.month === "05" || inputs.month === 5
                            ? true
                            : false
                        }
                      >
                        May
                      </option>
                      <option
                        value="06"
                        selected={
                          inputs.month === "06" || inputs.month === 6
                            ? true
                            : false
                        }
                      >
                        June
                      </option>
                      <option
                        value="07"
                        selected={
                          inputs.month === "07" || inputs.month === 7
                            ? true
                            : false
                        }
                      >
                        July
                      </option>
                      <option
                        value="08"
                        selected={
                          inputs.month === "08" || inputs.month === 8
                            ? true
                            : false
                        }
                      >
                        August
                      </option>
                      <option
                        value="09"
                        selected={
                          inputs.month === "09" || inputs.month === 9
                            ? true
                            : false
                        }
                      >
                        September
                      </option>
                      <option
                        value="10"
                        selected={
                          inputs.month === "10" || inputs.month === 10
                            ? true
                            : false
                        }
                      >
                        October
                      </option>
                      <option
                        value="11"
                        selected={
                          inputs.month === "11" || inputs.month === 11
                            ? true
                            : false
                        }
                      >
                        November
                      </option>
                      <option
                        value="12"
                        selected={
                          inputs.month === "12" || inputs.month === 12
                            ? true
                            : false
                        }
                      >
                        December
                      </option>
                    </select>
                  </div>

                </div>
                <div className="row mt-3">
                  <div className="col-lg">
                    <label>Remarks</label>
                    <textarea
                      className="form-control"
                      name="remarks"
                      value={inputs.remarks || ""}
                      onChange={handleChange}
                      placeholder="Remarks"
                    />
                  </div>
                </div>

                <div className="row mt-3">
                  <div className="col-3">
                    <button
                      className="btn btn-primary btn-block mg-b-10"
                      onClick={formSubmit}
                    >
                      <i className="fa fa-send mg-r-10"></i> Update
                    </button>
                  </div>
                </div>
              </>
            )}
          </div>
          {/* card */}
        </div>
      </div>
    </div>
  );
};

export default Edit;
